<template>
  <div>
    <v-dialog v-model="isOpen" persistent max-width="820">
      <v-card class="align-center text-center">
        <v-card-text>
          <div class="pt-5 mb-3">
            <v-row justify="space-between">
              <v-col cols="10" class="d-flex align-center">
                <div class="d-flex text-left text-truncate align-items-center">
                  <h1 class="mr-2">DETALHES DA IMPORTAÇÃO</h1>
                  <v-tooltip bottom nudge-top="1">
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <h1>- {{ truncateText(nfeXml.accessKey) }}</h1>
                      </div>
                    </template>
                    <span>{{ nfeXml.accessKey }}</span>
                  </v-tooltip>
                </div>
              </v-col>
              <v-col cols="2" class="d-flex justify-end">
                <v-btn color="error" large @click="close()">Fechar</v-btn>
              </v-col>
            </v-row>
          </div>
          <div class="mt10"></div>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">NÚMERO NFE</th>
                  <th class="text-left">ERROS</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(errorsItem, index) in nfeXml.errorsJson" :key="`errors-item-${index}`" class="text-left">
                  <td class="text-left">{{ nfeXml.number }}</td>
                  <td class="pt-5">
                    <p v-for="(error, errorIndex) in errorsItem.errors" :key="`error-${errorIndex}`">
                      {{ error }}
                    </p>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Base64Mixin from '@/mixins/base64.mixin';

export default {
  name: 'UploadXmlCte',
  props: {
    isOpen: {
      default: false,
      type: Boolean
    },
    nfeXml: {
      default: () => [{}],
      type: Object
    }
  },
  mixins: [Base64Mixin],
  data() {
    return {
      isLoading: true,
      activeTab: 0,
      headers: [
        {
          value: 'fileName',
          text: 'NOME DO ARQUIVO',
          sortable: true
        },
        {
          value: 'accessKeyCte',
          text: 'CHAVE CTE',
          sortable: true
        },
        {
          value: 'numberCte',
          text: 'NÚMERO',
          sortable: true
        },
        {
          value: 'statusName',
          text: 'STATUS',
          width: 220,
          sortable: true
        },
        {
          value: 'observation',
          text: 'ERROS',
          sortable: false
        }
      ]
    };
  },
  methods: {
    getAccessKeyCte(item) {
      let accessKeyCte;
      if (!item.accessKeyCte) {
        accessKeyCte = item.fileName.split('_')[0];
        return String(accessKeyCte);
      }
      return String(item.accessKeyCte);
    },
    truncateText(text) {
      return text && text.length > 20 ? text.substring(0, 18 - 3) + '...' : text;
    },
    getNumberCte(fileName) {
      const accessKeyCte = fileName.split('_')[0];
      const numberCte = accessKeyCte.substring(25, 34);
      return numberCte;
    },
    formatNumberCte(numberCte) {
      return String(numberCte).padStart(9, '0');
    },
    close() {
      this.$emit('update:isOpen', false);
    }
  }
};
</script>

<style lang="scss" scoped></style>
